import http from '@/libs/http'

export const getPhoneNumber = ()=>{
  return http.request({
    url: '/s/duopei-account/get-phone-number',
    method: 'get'
  })
}

export const getVerifiedCount = ()=>{
  return http.request({
    url: '/s/duopei-account/get-verified-count',
    method: 'get'
  })
}

export const sendVerifyCode = (data)=>{
  return http.request({
    url: '/s/duopei-account/send-verify-code',
    headers: {'Content-Type': 'application/json'},
    data,
    method: 'post'
  })
}

export const verify = (data)=>{
  return http.request({
    url: '/s/duopei-account/verify',
    headers: {'Content-Type': 'application/json'},
    data,
    method: 'post'
  })
}
